import { render } from "./ManagementSite.vue?vue&type=template&id=8039695a&scoped=true"
import script from "./ManagementSite.vue?vue&type=script&lang=js"
export * from "./ManagementSite.vue?vue&type=script&lang=js"

import "./ManagementSite.vue?vue&type=style&index=0&id=8039695a&scoped=true&lang=css"

import exportComponent from "/home/saes/central_authentication/central_authentication_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8039695a"]])

export default __exports__